import * as React from "react";
const SvgRoofSelected = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 240, height: 44, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", stroke: "#196600", d: "M120 .53 237.18 43.5H2.82z" }));
export default SvgRoofSelected;
